//-----------------------------------
// customers.js
// @=> theme/templates/customers/*.liquid
//-----------------------------------

import $ from 'jquery'

// Ignore ESLInt warnings on Globals
/* global
ga
*/


export let customers = {

  init() {
    customers.login();
    if( $('.Customer-amb').length ){
      console.log('customer is an amb');
      gtag('event', 'viewed_amb_dash', {
        'amb_code': $('.js-CustomerAMB-code').text()
      });
       
    }else{
      console.log('customer is NOT an amb');
    }

  },

  login() {

    $('.js-ForgotPassword').on('click', function() {
      switchToRecoverForm();
      return false;
    });

    // We also switch if we directly have the hash "recover"
    if (window.location.hash === '#recover' || window.recoverPassword === true) {
      switchToRecoverForm();
    }

    function switchToRecoverForm() {
      $('.js-CustomerForm--login, .js-CustomerForm--recover').toggle();
      $('.js-CustomerHeader-headline').text( 'Recover your password');
    }

    $('.CustomerHeaderNav-list').click(function(){
      $(this).toggleClass('is-open');
    });

  }

}
